<template>
  <nav aria-label="Page navigation example" v-if="pages.length > 0">
    <ul class="pagination">
      <li class="page-item" v-bind:class="{disabled: currentPage == 1 }">
        <router-link class="page-link" :to="{query: { page: currentPage - 1 }}">Previous</router-link>
      </li>
      <li class="page-item" v-for="page in pages" v-bind:class="{active: currentPage == page, disabled: page === '...' }">
        <router-link class="page-link" :to="{query: { page: page }}">{{page}}</router-link>
      </li>
      <li class="page-item" v-bind:class="{disabled: currentPage == totalPages }">
        <router-link class="page-link" :to="{query: { page: currentPage + 1 }}">Next</router-link>
      </li>
    </ul>
  </nav>
</template>

<script>
export default {
  name: 'pagination',
  props: ['currentPage', 'totalEntries', 'totalPages'],
  computed: {
    pages () {
      return this.paginate(this.currentPage, this.totalPages)
    }
  },
  methods: {
    paginate (current, total) {
      var delta = 2
      var left = current - delta
      var right = current + delta
      var range = []

      for (let i = 1; i <= total; i++) {
        if (i === 1 || i === total || (i >= left && i < right)) {
          range.push(i)
        } else {
          var last = range[range.length - 1]
          if (last !== '...') {
            range.push('...')
          }
        }
      }

      return range
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Pagination.vue